import { BaseLoginProvider } from '../entities/base-login-provider';
import { SocialUser } from '../entities/user';

declare let gapi: any;
export class GoogleLoginProvider extends BaseLoginProvider {
public static readonly PROVIDER_ID: string = "GOOGLE";

  protected auth2: any;
/**
 * @param {?} clientId
 */
constructor(private clientId: string) { super(); }
/**
 * @return {?}
 */
initialize(): Promise<SocialUser> {
    return new Promise((resolve, reject) => {
      this.loadScript(GoogleLoginProvider.PROVIDER_ID,
        "//apis.google.com/js/platform.js",
        () => {
          gapi.load('auth2', () => {
            this.auth2 = gapi.auth2.init({
              client_id: this.clientId,
              scope: 'email'
            });

            this.auth2.then(() => {
              if (this.auth2.isSignedIn.get()) {
                let /** @type {?} */ user: SocialUser = new SocialUser();
                let /** @type {?} */ profile = this.auth2.currentUser.get().getBasicProfile();
                let /** @type {?} */ token = this.auth2.currentUser.get().getAuthResponse(true).access_token;
                let /** @type {?} */ backendToken = this.auth2.currentUser.get().getAuthResponse(true).id_token;
    
                user.id = profile.getId();
                user.name = profile.getName();
                user.email = profile.getEmail();
                user.photoUrl = profile.getImageUrl();
                user.firstName = profile.getGivenName();
                user.lastName = profile.getFamilyName();
                user.authToken = token;
                user.idToken = backendToken;
                resolve(user);
              }
            });
          });
      });
    });
  }
/**
 * @return {?}
 */
signIn(): Promise<SocialUser> {
    return new Promise((resolve, reject) => {
      let /** @type {?} */ promise = this.auth2.signIn();

      promise.then(() => {
        let /** @type {?} */ user: SocialUser = new SocialUser();
        let /** @type {?} */ profile = this.auth2.currentUser.get().getBasicProfile();
        let /** @type {?} */ token = this.auth2.currentUser.get().getAuthResponse(true).access_token;
        let /** @type {?} */ backendToken = this.auth2.currentUser.get().getAuthResponse(true).id_token;

        user.id = profile.getId();
        user.name = profile.getName();
        user.email = profile.getEmail();
        user.photoUrl = profile.getImageUrl();
        user.authToken = token;
        user.idToken = backendToken;
        resolve(user);
      });
    });
  }
/**
 * @return {?}
 */
signOut(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.auth2.signOut().then((err: any) => {
        if (err) {
          reject(err);
        } else {
          resolve();
        }
      });
    });
  }

}

function GoogleLoginProvider_tsickle_Closure_declarations() {
/** @type {?} */
GoogleLoginProvider.PROVIDER_ID;
/** @type {?} */
GoogleLoginProvider.prototype.auth2;
/** @type {?} */
GoogleLoginProvider.prototype.clientId;
}

